import {createSlice} from "@reduxjs/toolkit";

// Restore state from sessionStorage on load
const savedState = null;

const defaultState = {
    startAddress: null,
    startLocation: null,
    endAddress: null,
    endLocation: null,
    currentLocation: null,
    startAddressEntrance: null,
    paymentMethod: "cash",
    babyChair: false,
    emptyTrunk: false,
    animalTransportation: false,
    driverAssistance: false,
    femaleCrew: false,
    comment: null,
    coupon: null,
    clientPhone: null,
    priorityAmount: 0,
};

const taxiSlice = createSlice({
    name: "taxi",
    initialState: savedState || defaultState,
    reducers: {
        setStartAddress: (state, action) => {
            state.startAddress = action.payload;
        },
        setStartLocation: (state, action) => {
            state.startLocation = action.payload;
        },
        setEndAddress: (state, action) => {
            state.endAddress = action.payload;
        },
        setEndLocation: (state, action) => {
            state.endLocation = action.payload;
        },
        setBabyChair: (state, action) => {
            state.babyChair = action.payload;
        },
        setEmptyTrunk: (state, action) => {
            state.emptyTrunk = action.payload;
        },
        setAnimlTransportation: (state, action) => {
            state.animalTransportation = action.payload;
        },
        setDriverAssistance: (state, action) => {
            state.driverAssistance = action.payload;
        },
        setFemaleCrew: (state, action) => {
            state.femaleCrew = action.payload;
        },
        setCurrentLocation: (state, action) => {
            state.currentLocation = action.payload;
        },
        setPaymentMethod: (state, action) => {
            state.paymentMethod = action.payload
        },
        setStartAddressEntrance: (state, action) => {
            state.startAddressEntrance = action.payload
        },
        setComment: (state, action) => {
            state.comment = action.payload
        },
        setCoupon: (state, action) => {
            state.coupon = action.payload
        },
        setClientPhone: (state, action) => {
            state.clientPhone = action.payload
        },
        setPriorityAmount: (state, action) => {
            state.priorityAmount = action.payload;
        }
    },
});


export default taxiSlice;